import * as React from "react";
import * as styles from "./PersonaSmall.css";
import { IAIcon } from "../../../icon/Icon";
import { Helper } from "./../../../../Helper";
import { MSPersonCard } from "../../../msPersonCard/MSPersonCard";
import { IFontSlots } from "../../../../interfaces/IFontSlots";

export interface IPersonaSmallProps {
  name: string;
  userId: string;
  metadata?: any;
  profileImage?: string;
  backgroundColor?: string;
  styles?: React.CSSProperties;
  numMetaData?: number;
  listViewStyle?: boolean;
  highlightColor: string;
  todayIcon?: string;
  isToday: boolean;
  cardHeight: string;
  userLoginName?: string;
  isEditMode?: boolean;
  fontSlots?: IFontSlots;
}

export class IAPersonaSmall extends React.Component<IPersonaSmallProps> {
  public render(): JSX.Element {
    let firstNameChar =
      this.props.name != undefined
        ? this.props.name.split(" ")[0].charAt(0)
        : "";
    let lastNameChar =
      this.props.name != undefined
        ? this.props.name
          .split(" ")
        [this.props.name.split(" ").length - 1].charAt(0)
        : "";

    const personaSmallImage = (
      <div
        className={styles.IA_personaSmallProfileImage}
        style={{
          backgroundImage: `url('${this.props.profileImage}')`,
        }}
      />
    );

    let profileImage = (
      <div
        className={styles.IA_personaSmallProfileImageWrapper}
        style={{
          backgroundColor:
            this.props.backgroundColor != undefined ?
              Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.backgroundColor, "#ffffff", "#333333")
              :
              "#333333",
          color:
            this.props.backgroundColor != undefined ?
              Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.backgroundColor, "#333333", "#ffffff")
              :
              "#ffffff",
          //marginTop: this.props.numMetaData ? (5*this.props.numMetaData).toString() + 'px' : '1px',
          marginRight:
            !this.props.listViewStyle || !this.props.listViewStyle
              ? "9px"
              : "12px",
        }
        }
      >
        {
          this.props.isToday && (
            <div
              className={styles.IA_notificationToday}
              style={{
                backgroundColor: this.props.highlightColor,
              }}
            >
              <div className={styles.IA_notificationIcon}>
                <IAIcon
                  title={
                    this.props.todayIcon ? this.props.todayIcon : "Balloons"
                  }
                  size={18}
                  color={
                    this.props.highlightColor != undefined
                      ? Helper.getTextColorBasedOnBackgroundColorDarkness(
                        this.props.highlightColor,
                        "#f4f4f4",
                        "#333333"
                      )
                      : "#f4f4f4"
                  }
                />
              </div>
            </div>
          )
        }

        < div className={styles.IA_personaSmallProfileImageText} >
          {firstNameChar + lastNameChar}
        </div >
        {this.props.userLoginName ?
          <div
            className={styles.IA_profile_link}
            onClick={() => Helper.openProfilePageWithUserId(this.props.userLoginName, this.props.userId)}
          >
            {personaSmallImage}
          </div>
          :
          personaSmallImage
        }
      </div >
    );

    const personaSmallName = (
      <div
        className={styles.IA_personaSmallName}
        style={
          !this.props.metadata ?
            {
              width: "auto",
              marginTop: "7px",
              fontFamily: this.props.fontSlots?.heading?.fontFamily
            }
            :
            {
              fontFamily: this.props.fontSlots?.heading?.fontFamily
            }
        }
      >
        {this.props.isEditMode
          ?
          this.props.name
          :
          <MSPersonCard
            userLoginName={this.props.userLoginName}
            userProfileImage={this.props.profileImage}
            highlightColor={this.props.highlightColor}
          >
            {this.props.name}
          </MSPersonCard>
        }
      </div>
    );

    return (
      <div className={styles.IA_personaSmall} style={this.props.styles}>
        <>
          {this.props.isEditMode
            ?
            profileImage
            :
            <MSPersonCard
              userLoginName={this.props.userLoginName}
              userProfileImage={this.props.profileImage}
              highlightColor={this.props.highlightColor}
            >
              {profileImage}
            </MSPersonCard>
          }
        </>
        {this.props.userLoginName ?
          <div
            className={styles.IA_profile_link}
            onClick={() => Helper.openProfilePageWithUserId(this.props.userLoginName, this.props.userId)}
          >
            {personaSmallName}
          </div>
          :
          personaSmallName
        }
        {this.props.metadata && (
          <div className={styles.IA_personaSmallMetadata}
            style={{
              height: this.props.cardHeight
            }}>
            {this.props.metadata}
          </div>
        )}
      </div>
    );
  }
}
